var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5694 70.0032C65.0967 62.7352 63.801 54.626 63.801 45.7923C63.801 36.9586 65.1399 28.1482 67.7529 20.5881H16.086C14.8227 28.4871 14.1641 36.7833 14.1641 45.4534C14.1641 54.1235 14.7687 62.2328 15.9564 69.9915H67.5802L67.5694 70.0032Z",
    fill: "#00C5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3578 52.3476L22.7061 54.9971L22.9185 61.2022L28.1072 62.054L28.3578 52.3476Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0634 52.3476L32.4116 54.9971L32.624 61.2022L37.8128 62.054L38.0634 52.3476Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7521 9.98794L32.4116 16.0094L32.9882 30.112L47.0719 32.0479L47.7521 9.98794Z",
    fill: "#FFC508"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7694 52.3476L42.1177 54.9971L42.3301 61.2022L47.5188 62.054L47.7694 52.3476Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4755 52.3476L51.8237 54.9971L52.0361 61.2022L57.2249 62.054L57.4755 52.3476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.83c2ddb1ca020a28f5eb59d11ecfde57.svg";
export { ForwardRef as ReactComponent };